import React from 'react';
import { UrgencyBar } from '../components/sales/UrgencyBar';
import { SalesHero } from '../components/sales/SalesHero';
import { HookSection } from '../components/sales/HookSection';
import { PainSection } from '../components/sales/PainSection';
import { RevelationSection } from '../components/sales/RevelationSection';
import { OfferVitrine } from '../components/sales/OfferVitrine';
import { TransformationBand } from '../components/sales/TransformationBand';
import { TestimonialsCarousel } from '../components/sales/TestimonialsCarousel';
import { FaqAccordion } from '../components/sales/FaqAccordion';
import { GuaranteeBlock } from '../components/sales/GuaranteeBlock';
import { FinalCta } from '../components/sales/FinalCta';
import { SalesStickyBar } from '../components/sales/SalesStickyBar';
import { LiveViewers } from '../components/sales/LiveViewers';
import { SalesNotifications } from '../components/sales/SalesNotifications';
import { useMetaPixel } from '../hooks/useMetaPixel';
import { useResourceHints, type ResourceHint } from '../hooks/useResourceHints';
import { CHECKOUT_URL, OFFER_ANCHOR, metaPixel, faqs, finalCta, guarantee, hero, hook, liveViewers, offer, pain, revelation, salesNotificationProduct, salesNotifications, salesStickyBar, socialProof, testimonials, transformation, urgencyBar } from '../data/salesPage';
const PIXEL_HINTS: ResourceHint[] = [{
  href: 'https://connect.facebook.net'
}];
interface SalesPageProps {
  showStickyCta: boolean;
  showLiveActivity: boolean;
}
export function SalesPage({
  showStickyCta,
  showLiveActivity
}: SalesPageProps) {
  useResourceHints(PIXEL_HINTS);
  useMetaPixel({
    pixelId: metaPixel.id,
    pageViewEvent: metaPixel.pageViewEvent
  });
  return <div className="min-h-screen w-full overflow-x-hidden bg-ink" data-id="element-356" data-mp="3fijmyk8gpw6z">
      <noscript data-id="element-357" data-mp="285htdy7j2q5h">
        <img height="1" width="1" alt="" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${metaPixel.id}&ev=PageView&noscript=1`} data-id="element-358" data-mp="28615uzeesmc4" />
      </noscript>

      <UrgencyBar label={urgencyBar.label} text={urgencyBar.text} spotsLeft={urgencyBar.spotsLeft} data-id="element-359" data-mp="25iqn70epehqn" />

      <main data-id="element-360" data-mp="2ahtrujqruly3">
        <SalesHero content={hero} data-id="element-361" data-mp="1vmnne17bqv6v" />
        <HookSection content={hook} data-id="element-362" data-mp="1vnfaenmuvklj" />
        <PainSection content={pain} data-id="element-363" data-mp="1vmdxedma4o16" />
        <RevelationSection content={revelation} data-id="element-364" data-mp="20lgqczozj3ss" />
        <OfferVitrine content={offer} checkoutUrl={CHECKOUT_URL} data-id="element-365" data-mp="20k5mkzvjhw1o" />
        <TransformationBand items={transformation} data-id="element-366" data-mp="1mu248jzs6mhi" />
        <TestimonialsCarousel title={socialProof.title} subtitle={socialProof.subtitle} stats={socialProof.stats} items={testimonials} data-id="element-367" data-mp="1ms913eodmke9" />
        <FaqAccordion items={faqs} data-id="element-368" data-mp="1cxz3nikkuvwo" />
        <GuaranteeBlock content={guarantee} data-id="element-369" data-mp="1huzbnz0zm8qf" />
        <FinalCta content={finalCta} checkoutUrl={OFFER_ANCHOR} price={offer.price} totalValue={offer.totalValue} data-id="element-370" data-mp="1hvqwcet1qm1x" />
      </main>

      <footer className="border-t border-white/[0.07] bg-ink px-5 pb-24 pt-10 sm:px-6 md:pb-10" data-id="element-371" data-mp="17xb76hdkxmv2">
        <div className="mx-auto max-w-3xl text-center" data-id="element-372" data-mp="p7zcq5rd18n9">
          <p className="font-mono text-[10px] tracking-[0.22em] text-gold/80" data-id="element-373" data-mp="pals2rkhssg1">NEURO-PUREZA</p>
          <p className="mt-3 text-[12.5px] font-light leading-relaxed text-ash/70" data-id="element-374" data-mp="kc0rus58q8rl">
            Este material es de carácter educativo y espiritual, y no sustituye el consejo médico,
            psicológico ni pastoral profesional. Los resultados varían según cada persona.
          </p>
          <p className="mt-4 font-mono text-[10px] tracking-[0.12em] text-ash/50" data-id="element-375" data-mp="185sayur1gueb">
            © {new Date().getFullYear()} — Todos los derechos reservados.
          </p>
        </div>
      </footer>

      {showLiveActivity && <>
          <LiveViewers baseCount={liveViewers.baseCount} label={liveViewers.label} note={liveViewers.note} data-id="element-376" data-mp="1cxtmufkaoj3t" />
          <SalesNotifications items={salesNotifications} product={salesNotificationProduct} data-id="element-377" data-mp="1qye8rkliav1j" />
        </>}

      {showStickyCta && <SalesStickyBar label={salesStickyBar.label} hint={salesStickyBar.hint} buttonLabel={salesStickyBar.buttonLabel} href={OFFER_ANCHOR} data-id="element-378" data-mp="261nyzxiz7n1a" />}
    </div>;
}